import React, {useEffect, useState, useMemo} from 'react'
import {IconButton, Modal, Button} from '@material-ui/core'
import {Close} from '@material-ui/icons'
import moment from 'moment'
import _ from 'lodash'
// custom components
import {Tab, TabPanel, Tabs} from '../CalendarEventPopup/Tabs'
import {useGetGroupActions} from '../../state/groups/get-group-actions/hooks'
import {useGetGroupActionFields} from '../../state/groups/get-group-action-fields/hooks'
import LoadingIndicator from '../ReservationConfiguration/LoadingIcon'
import useGetReservationItemDetails from '../../state/get-reservation-item-details/reducer'
// styles
// will use styles calendar event popup

const CalendarEventActionDatePopup = ({onClose, open, data = {}}) => {
  const [tabIndex, setTabIndex] = useState(0)
  const {field = {}, action = {}, action_data, entity_object = {}} = data

  const {state: groupActions, call: callGetGroupActions} = useGetGroupActions()
  const {state: groupActionFields, call: callGetGroupActionFields} = useGetGroupActionFields()

  const entity_id = entity_object?.entity?.id || data?.entity_id
  const action_id = action?.action_id || data?.entity_action_id

  const entity_object_id = entity_object?.id || data?.entity_object_id
  const entity_key = data?.entity_key

  const [reservation, dispatch] = useGetReservationItemDetails()
  const {status = '', states = ''} = reservation.data || {}

  useEffect(() => {
    callGetGroupActions({group_id: entity_id, params: {action_ids: action_id}})
  }, [entity_id, action_id, callGetGroupActions])

  useEffect(() => {
    callGetGroupActionFields({group_id: entity_id, action_id: action_id, all_fields: true})
  }, [entity_id, action_id, callGetGroupActionFields])

  const returnInfo = useMemo(() => {
    setTabIndex(0)
    if (_.isEmpty(groupActions.data)) return null
    // fetch action
    const _action = groupActions.data[0]

    if (_.isEmpty(groupActionFields.data)) return null
    // fetch closed fields
    let _fields = _.toArray(groupActionFields.data)[0].filter(f => !f.is_open_field)

    if (_.isEmpty(_fields)) return null

    const _data = action_data?.values || data.action_values || {}
    if (_.isEmpty(_data)) return null

    // map items
    let items = _fields.map(f => ({field_name: f.name, value: _data[f.key]}))
    if (!items.some(e => e.value)) return null

    return {
      name: _action?.return_name || `Return ${_action?.name || data?.display_name}`,
      items,
    }
  }, [groupActions, groupActionFields, action_data, data])

  const getFieldValue = field_key => {
    if (action_data) {
      return action_data?.values[field_key] || '-'
    } else {
      return data?.action_values[field_key] || '-'
    }
  }

  const [full_value, new_value] = useMemo(() => {
    let reservationID = ''
    const prepareValue = val => {
      let display_value
      if ((val !== null && val !== undefined && val.length > 0) || typeof val == 'number') {
        display_value = `${val},`
      } else {
        display_value = ''
      }
      return display_value
    }
    if (!_.isEmpty(data?.reservation_uid)) {
      reservationID = `#${data?.reservation_uid},`
    } else if (!_.isEmpty(data?.entity_display_name)) {
      reservationID = data?.entity_display_name
    }
    const first_name = prepareValue(data.display_name_first || entity_object?.display_name)
    const second_name = prepareValue(
      data.display_with_secondary || entity_object?.display_with_secondary
    )
    const third_name = prepareValue(data.display_name_third || entity_object?.display_name_third)
    const full_value = `${first_name} ${second_name} ${third_name}`.replace(/,\s*$/, '')
    const _new_value =
      full_value.trim() !== '' ? full_value : `${reservationID}`.replace(/,\s*$/, '')
    const _full_value =
      full_value.trim() !== '' ? full_value : ` ${reservationID} ${status} - ${states}`
    return [_full_value, _new_value]
  }, [data, status, states, entity_object])

  return (
    <Modal open={!!open} onClose={onClose}>
      <>
        <div
          className="c-res-mod c-calendar-event-popup"
          style={{borderLeft: `8px solid ${data.bgColor ? data.bgColor : data.color}`}}
        >
          <div
            className="c-calendar-event-popup__header"
            // style={{backgroundColor: `${data.bgColor ? data.bgColor : data.color}3f`}}
          >
            <h4 className="c-calendar-event-popup__header-title ap-typography ap-typography--lg ap-typography--light ap-ellipsis">
              <a
                style={{color: 'inherit'}}
                href={`${localStorage.parent_origin}/${entity_key}/${entity_object_id}`}
                target="_top"
                className="tooltip-header-title"
              >
                {new_value}
                <span className="tooltip-after"></span>
                <span className="tooltip-title-text">{full_value}</span>
              </a>
            </h4>
            {/* <IconButton
              className="c-calendar-event-popup__header-close ap-icon-button ap-icon-button--square"
              size="small"
              onClick={onClose}
            >
              <Close />
            </IconButton> */}
          </div>

          <div className="c-calendar-event-popup__body">
            <div className="c-calendar-event-popup__tab-wrapper">
              <Tabs>
                <Tab
                  active={tabIndex === 0}
                  onClick={e => setTabIndex(0)}
                  style={{borderColor: `${data.bgColor ? data.bgColor : data.color}`}}
                  title={action?.name || data.display_name}
                  className={`tab-count-${returnInfo ? 2 : 1}`}
                >
                  {action.name || data.display_name}
                </Tab>
                {returnInfo && (
                  <Tab
                    active={tabIndex === 1}
                    onClick={e => setTabIndex(1)}
                    style={{borderColor: `${data.bgColor ? data.bgColor : data.color}`}}
                    title={returnInfo.name}
                    className={`tab-count-2`}
                  >
                    {returnInfo.name}
                  </Tab>
                )}
              </Tabs>
              <TabPanel active={tabIndex === 0}>
                {groupActionFields.isLoading && <LoadingIndicator />}
                {!groupActionFields.isLoading &&
                  groupActionFields?.data[`${entity_id}_${action_id}`] &&
                  groupActionFields?.data[`${entity_id}_${action_id}`].map(field_item => {
                    if (field_item?.is_open_field) {
                      return (
                        <div className="ap-mb-28">
                          <p className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                            {field_item.name}
                          </p>
                          <p className="tab-label-value ap-m-0 ap-typography ap-typography--sm">
                            {getFieldValue(field_item.key)}
                          </p>
                        </div>
                      )
                    }
                  })}
              </TabPanel>

              {returnInfo && (
                <TabPanel active={tabIndex === 1}>
                  {returnInfo.items.map((item, i) => {
                    let val =
                      typeof item.value === 'object' && !!item.value
                        ? item.value.display_name
                        : item.value

                    return (
                      <div key={i} className="ap-mb-4">
                        <p className="ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                          {item.field_name}
                        </p>
                        {!_.isNil(val) && (
                          <p className="ap-m-0 ap-typography ap-typography--sm">{val}</p>
                        )}
                        {_.isNil(val) && (
                          <p className="ap-m-0 ap-typography ap-typography--sm ap-typography--gray">
                            n/a
                          </p>
                        )}
                      </div>
                    )
                  })}
                </TabPanel>
              )}
            </div>
          </div>
          <div className="c-calendar-event-popup__footer">
            <Button
              onClick={onClose}
              style={{width: 80, textTransform: 'capitalize'}}
              // className="ap-button ap-button--text font-bold"
            >
              Close
            </Button>
          </div>
        </div>
      </>
    </Modal>
  )
}

export default CalendarEventActionDatePopup
